import React from "react";

import LoginRegisterPasswords from "../../components/login-register-passwords/login-register-passwords.component";
const HomePage = () => {
  return <LoginRegisterPasswords />;
};
export default HomePage;
